import {en as privatisation_en} from './privatisation/en';
import {en as google} from './gogole/en';

const en_US = {
    'header_title': 'Developer Platform',
    'home_title': 'Qingping Developer Platform',
    'do_yourself': 'Create Rules by Yourself',
    'deep_customize': 'Let Qingping products connect perfectly to your platform.',
    'start': 'Preview',
    'login': 'Log In',
    'checkout_docs': 'Checkout Docs',
    'cancel': 'Cancel',
    'consent': 'Confirm',
    'consent_title': 'Authorize to obtain the following information:',

    'welcome': 'Log In',
    'phone': 'Mobile Number ',
    'phone_login': 'Mobile Number',
    'email_login': 'Email',
    'password': 'Password',
    'code': 'Code',
    'send': 'Send',
    'via_email': 'Log In via Email',
    'via_password': 'Log In via Password',
    'via_verify': 'Log In via Verification Code',
    'email': 'Email Address ',
    'desc_1': 'Log in with your Qingping account. If you do not have one, please register via ',
    'desc_1_1': 'Qingnping IoT app',
    'desc_2': ' or ',
    'desc_3': 'Qingping+ app',
    'desc_4': '. ',
    'input_account':'Please input your account',
    'input_correct':'Please enter a valid ',
    'email_txt':'email format',
    'phone_txt':'phone number',


    'docs': 'Docs',
    'get_stared': 'Get started',
    'guideline': 'Guideline',
    'qingping_air_monitor': 'Qingping Air Monitor',
    'dany': 'Qingping Air Monitor Lite',
    'RH_WIFI': 'Qingping Temp & RH Barometer (Wi-Fi)',
    'RH_NB_IOT': 'Qingping Temp & RH Barometer (NB-IoT)',
    'RH_LoRa': 'Qingping Temp & RH Barometer (LoRa)',
    'RH_PRO_WIFI': 'Qingping Temp & RH Monitor (Pro Wi-Fi)',
    'RH_PRO_NB_IOT': 'Qingping Temp & RH Monitor (Pro NB-IoT)',
    'access': 'Access',
    'instruction': 'Instructions',
    'OAuth': 'OAuth 2.0',
    'open_interface': 'Open API',
    'data_push': 'Data Push',
    'SDK_instruction': 'SDK Instructions',
    'private_cloud': 'Private Cloud',
    'private_deployment': 'Private',
    'SDK': 'SDK',
    'RH_LoRa_WAN': 'Qingping Temp & RH Barometer LoRaWAN Version Protocol',

    'my': 'My',
    'access_managemennt': 'Access Managemennt',
    'apply_access': 'Apply Access',
    'access_information': 'Access Management',
    'apply_app_key_and_app_secret': 'Apply App Kay and App Secret',
    'data_push_setting': 'Data Push Setting',
    'webhook_setting': 'Webhook setting',
    'MQTT_setting': 'MQTT setting',
    'device_data_webhook': 'Device Data Webhook',
    'address_optional': 'Address(Optional)',
    'device_time_webhook': 'Device Event Webhook',
    'edit': 'Edit',
    'others': 'Others',
    'feedback': 'Feedback',
    'issueTip': 'Please submit your question in the "More > Contact Us"  of Qingping+ app or Qingping IoT app. Thank you.',
    'help': 'How can we help you?',
    'contact': 'Enter your phone number, WeChat or email so that we can get in touch with you.',
    'feedback_suggestion': 'Feedback',
    'logout': 'Log out',
    'apply': 'Apply',
    'save': 'Save',
    'clear': 'Clear',
    'before': 'Before',
    'data': 'Data',
    'event': 'Event',
    'user_name': 'User Name',
    'user_secret': 'User Secret',
    'broker_list': 'Broker List',
    'client_id_prefix': 'Client',
    test: 'Test',
    confirm: 'Confirm',
    add: 'Add Field',

    "account_or_password_error": "Account or password error",
    "captcha_limit_exceeded": "Captcha limit exceeded",
    "username_or_password_limit_exceeded": "Username or password error limit exceeded",
    "user_type_error": "User type error",
    
    login_failed_pwd_error: 'Incorrect password. Please try again or log in via verification code.',
    login_failed_account_not_exist:'The account isn\'t registered.',
    verification_to_many: 'Too many verifications. Please try again in 10 minutes.',
    verification_code_error: 'Invalid code, please check the code and try again.',


    ...privatisation_en,
    ...google,
};

export default en_US;
